module.exports = __webpack_public_path__ + "static/media/0_2020_03_25.dcd6cb63.jpg";